import React from "react";

export default function RadioGroup({ name, label, required, value, onChange, options = [] }) {
  return (
    <div>
      {label && (
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500, color: '#374151' }}>
          {label} {required && <span style={{ color: '#dc2626' }}>*</span>}
        </label>
      )}
      <div style={{ display:'flex', gap:'1rem', flexWrap:'wrap' }}>
        {options.map((opt) => (
          <label key={opt.value} style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }}>
            <input type="radio" name={name} value={opt.value} checked={value === opt.value} onChange={(e)=> onChange?.(name, e.target.value)} />
            {opt.label}
          </label>
        ))}
      </div>
    </div>
  );
}